import { sportConstants } from '../_constants';

export function sports(state = {}, action) {
//	console.log('sports reducer was called with state', state, 'and action', action)
    switch (action.type) {
        case sportConstants.GET_SPORTS_SUCCESS:
            return {
							...state,
							items: action.sports,
							isLoading: false
						};
        case sportConstants.GET_SPORTS_REQUEST:
            return {isLoading: true};
        case sportConstants.GET_SPORTS_FAILURE:
            return {
							hasErrored: action.hasErrored,
							isLoading: false
						};
				case sportConstants.SPORT_SELECTED:
					return {
						...state,
						selectedSport: action.sport
					};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/sports.js